import { Box } from '@mui/material'
import { useParams } from 'react-router-dom'

import { USER_ROLES } from '@/constants/userRoles'
import { useAuth } from '@/features/authentication/contexts/AuthContext'
import { usePartnersQuery } from '@/features/partner/hooks/usePartnersQuery'
import { useSitesQuery } from '@/features/site/hooks/useSitesQuery'
import { PartnerUserForm } from '@/features/user/components/PartnerUserForm'
import { UserForm } from '@/features/user/components/UserForm'
import { useUserQuery } from '@/features/user/hooks/useUserQuery'

export default function UserEdit() {
  const { id } = useParams()
  const { loggedInUser } = useAuth()
  const { sites } = useSitesQuery()
  const { user } = useUserQuery({ id: id! }, { enabled: id !== null && id !== undefined })
  const { partners } = usePartnersQuery({ enabled: isCurrentUserAdmin() })

  function isCurrentUserAdmin() {
    return loggedInUser?.role === USER_ROLES.ADMINISTRATORS.value
  }

  function isCurrentUserPartnerAdmin() {
    return loggedInUser?.role === USER_ROLES.PARTNER_ADMINISTRATORS.value
  }

  if (!user) {
    return null
  }

  return (
    <Box sx={{ marginY: 3 }}>
      {isCurrentUserAdmin() && <UserForm partners={partners ?? []} sites={sites ?? []} user={user} />}

      {isCurrentUserPartnerAdmin() && <PartnerUserForm sites={sites ?? []} user={user} />}
    </Box>
  )
}
